import type { RovoLogo } from '../../constants/icons';
import { ProductKeys3P } from '../../constants/product-keys';
import type { ProductKeys } from '../../constants/product-keys';
import type { ProductConfig } from '../../constants/products';

const FALLBACK_ORDER: ProductKeys3P[] = [ProductKeys3P.GoogleDrive, ProductKeys3P.Slack];

/**
 * Returns two 3P icon components for the "all apps" icon strip.
 *
 * Uses the user's newly connected 3P products (most recent first).
 * Falls back to Google Drive then Slack icons when fewer than 2 connected 3P apps are available.
 *
 * Pure utility — accepts dependencies as arguments so it can be used from common/ without
 * importing from controllers/.
 */
export const getConnected3PIcons = (
	newlyConnectedProducts: ProductKeys3P[],
	productConfigs: Partial<Record<ProductKeys, ProductConfig>>,
): [RovoLogo, RovoLogo] => {
	// Fill slots from newlyConnectedProducts, then fallbacks
	const icons: RovoLogo[] = newlyConnectedProducts
		.slice(0, 2)
		.map((pk) => productConfigs[pk]?.Icon)
		.filter(Boolean) as RovoLogo[];

	// Fill remaining slots with fallback icons (Google Drive, then Slack)
	for (const fallbackKey of FALLBACK_ORDER) {
		if (icons.length >= 2) {
			break;
		}
		const fallbackIcon = productConfigs[fallbackKey]?.Icon;
		if (fallbackIcon && !icons.includes(fallbackIcon)) {
			icons.push(fallbackIcon);
		}
	}

	return icons as [RovoLogo, RovoLogo];
};
